export default function sanitize(url) {
    return encodeURI(url);
}
